import { NavLink, Outlet } from 'react-router-dom';
import { Roles } from '@tips-sso/shared';
import { useAuth } from '../auth/AuthContext.js';

interface NavItem {
  to: string;
  label: string;
  end?: boolean;
}

const adminNav: NavItem[] = [
  { to: '/tipsconnect/admin/orgs', label: 'Organizations' },
  { to: '/tipsconnect/admin/resellers', label: 'Resellers' },
];

const salesNav: NavItem[] = [{ to: '/tipsconnect/admin/sales/accounts', label: 'Sales Accounts' }];

const platformNav: NavItem[] = [
  { to: '/tipsconnect/admin/scim', label: 'SCIM' },
  { to: '/tipsconnect/admin/audit', label: 'Audit Explorer' },
];

function navClass({ isActive }: { isActive: boolean }) {
  return `nav-link${isActive ? ' nav-link--active' : ''}`;
}

export function Layout() {
  const { identity, logout, hasAnyRole } = useAuth();

  const isAdmin = hasAnyRole([Roles.TipsConnectAdmin]);
  const isSalesOps = hasAnyRole([Roles.TipsConnectSalesOpsUser]);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <span className="sidebar__logo">◆</span>
          <span>TipsConnect</span>
        </div>

        <nav className="sidebar__nav" aria-label="Primary">
          {(isAdmin || isSalesOps) && (
            <div className="nav-group">
              <span className="nav-group__label">Admin</span>
              {adminNav.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className={navClass}>
                  {item.label}
                </NavLink>
              ))}
            </div>
          )}

          <div className="nav-group">
            <span className="nav-group__label">Sales Ops</span>
            {salesNav.map((item) => (
              <NavLink key={item.to} to={item.to} className={navClass}>
                {item.label}
              </NavLink>
            ))}
          </div>

          {isAdmin && (
            <div className="nav-group">
              <span className="nav-group__label">Platform</span>
              {platformNav.map((item) => (
                <NavLink key={item.to} to={item.to} className={navClass}>
                  {item.label}
                </NavLink>
              ))}
            </div>
          )}
        </nav>

        <div className="sidebar__footer">
          {identity && (
            <div className="user-chip">
              <div className="user-chip__avatar">
                {identity.displayName.charAt(0).toUpperCase()}
              </div>
              <div className="user-chip__meta">
                <span className="user-chip__name">{identity.displayName}</span>
                <span className="user-chip__role">{identity.email}</span>
              </div>
            </div>
          )}
          <button
            type="button"
            className="btn btn--ghost btn--block"
            onClick={() => void logout()}
          >
            Sign out
          </button>
        </div>
      </aside>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
